import { useState, useEffect } from 'react';
/**
 * This hook returns a unique key for each load including BfCached loads
 */
export const useRemountKeyOnBfCache = () => {
    const [pageLoadNumber, setPageLoadNumber] = useState(0);
    useEffect(() => {
        window.addEventListener('pageshow', (event) => {
            if (event.persisted) {
                setPageLoadNumber((pageNumber) => pageNumber + 1);
            }
        });
    }, []);
    return {
        pageLoadNumber,
    };
};
//# sourceMappingURL=useRemountKeyOnBfCachedLoad.js.map